(function () {
  const setupAnimation = (section) => {
    const container = section.querySelector(".block-animated-heading");
    const hasAnimatedHeading =
      container && container.dataset.enableAnimation === "true";

    if (section._scrollTrigger) {
      section._scrollTrigger.kill();
    }

    const master = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        end: "bottom 20%",
        toggleActions: "play none none none",
        invalidateOnRefresh: true,
        once: true,
      },
    });

    section._scrollTrigger = master.scrollTrigger;

    if (hasAnimatedHeading) {
      const otherBlocks = section.querySelectorAll(
        ".media-banner__content > *:not(.block-animated-heading)"
      );
      const media = section.querySelector(".media-banner__media");
      const lines = container.querySelectorAll(".block-animated-heading-line");
      if (!lines.length) return;

      const mm = gsap.matchMedia();
      gsap.registerPlugin(ScrollTrigger);
      mm.add(
        {
          isMobile: "(max-width: 575px)",
          isTablet: "(min-width: 576px) and (max-width: 989px)",
          isDesktop: "(min-width: 990px)",
        },
        (context) => {
          const { isTablet, isDesktop } = context.conditions;
          let widthKoeff = 0.5;
          if (isTablet) widthKoeff = 0.75;
          else if (isDesktop) widthKoeff = 1;

          if (typeof window.animatedHeadingCalcFontSize === "function") {
            window.animatedHeadingCalcFontSize(lines, container, widthKoeff);
          }

          if (otherBlocks.length) gsap.set(otherBlocks, { opacity: 0, y: 12 });
          if (media) {
            gsap.set(media, { scale: 1 });
            master.to(
              media,
              {
                scale: 1.1,
                duration: 1,
                ease: "power2.out",
              },
              "0.2"
            );
          }

          lines.forEach((line, lineIndex) => {
            const texts = line.querySelectorAll(".block-text-fragment");
            const images = line.querySelectorAll(".block-image");

            texts.forEach((textEl) => {
              if (textEl.classList.contains("text-animation-initialized")) {
                return;
              }

              textEl.classList.add("text-animation-initialized");

              const wrapTextNodes = (node) => {
                const childNodes = Array.from(node.childNodes);

                childNodes.forEach((child) => {
                  if (child.nodeType === Node.TEXT_NODE) {
                    const text = child.textContent;
                    const chars = text.split("");
                    const fragment = document.createDocumentFragment();

                    chars.forEach((c) => {
                      const span = document.createElement("span");
                      span.className = "char";
                      span.textContent = c === " " ? "\u00A0" : c;
                      fragment.appendChild(span);
                    });

                    child.replaceWith(fragment);
                  } else if (child.nodeType === Node.ELEMENT_NODE) {
                    wrapTextNodes(child);
                  }
                });
              };

              wrapTextNodes(textEl);
            });

            const allCharSpans = line.querySelectorAll(".char");
            gsap.set(images, { clearProps: "width" });
            gsap.set(images, { width: 0, opacity: 0 });
            gsap.set(allCharSpans, { opacity: 0.1 });

            const tlLine = gsap.timeline();
            const widthValue = `calc(var(--heading-image-width) * ${widthKoeff}px)`;

            const children = Array.from(line.children);

            children.forEach((child) => {
              if (child.classList.contains("block-text-fragment")) {
                const charSpans = child.querySelectorAll(".char");
                tlLine.to(
                  charSpans,
                  {
                    opacity: 1,
                    duration: 0.6,
                    stagger: { each: 0.04 },
                    ease: "power1.inOut",
                  },
                  ">"
                );
              } else if (child.classList.contains("block-image")) {
                tlLine.fromTo(
                  child,
                  {
                    width: 0,
                    opacity: 0,
                  },
                  {
                    width: widthValue,
                    opacity: 1,
                    duration: 0.5,
                    ease: "power1.inOut",
                  },
                  ">-0.6"
                );
              }
            });

            if (lines.length === 2) {
              master.add(tlLine, lineIndex === 0 ? 0 : ">-1");
            } else {
              master.add(tlLine, 0);
            }
          });

          master.to(
            otherBlocks,
            {
              opacity: 1,
              y: 0,
              duration: 0.5,
              ease: "power1.out",
              stagger: 0.1,
            },
            ">-0.8"
          );
        }
      );
    } else {
      const otherBlocks = section.querySelectorAll(
        ".media-banner__content > *"
      );
      const media = section.querySelector(".media-banner__media");
      gsap.set(media, { scale: 1 });
      gsap.set(otherBlocks, { opacity: 0, y: 20 });
      if (media) {
        master.to(
          media,
          {
            scale: 1.1,
            duration: 1,
            ease: "power1.out",
          },
          "0.1"
        );
      }
      master.to(
        otherBlocks,
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power1.out",
          stagger: 0.1,
        },
        "-=0.6"
      );
    }
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains("media-banner-section")) {
      return;
    }

    const contentWrapper = section.querySelector(".media-banner");
    if (!contentWrapper) return;

    const hasAnimation = contentWrapper.dataset.appearanceAnimation === "true";
    if (!hasAnimation) return;

    if (section._animationInitialized) return;
    section._animationInitialized = true;

    setupAnimation(section);

    let resizeTimeout;
    let lastWidth = window.innerWidth;

    window.addEventListener("resize", () => {
      const currentWidth = window.innerWidth;

      if (currentWidth === lastWidth) return;

      lastWidth = currentWidth;

      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setupAnimation(section);
        ScrollTrigger.refresh();
      }, 400);
    });
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });
})();
